export default {
	title: 'application_settings',
	components: [
		{
			title: 'device_card_customization',
			component: 'customize_device_content',
		},
		{ title: 'appliance_type', component: 'appliance_type' },
		{ title: 'pin_lock', component: 'pin_lock' },
		{ title: 'input_state', component: 'input_state' },
		{ title: 'exclude_event_log', component: 'exclude_event_log' },
		{
			title: 'exclude_forgotten_lights',
			component: 'exclude_forgotten_lights',
			premium: true,
		},
	],
};
